var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg25DaysHoliday(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 233.3 200",
    style: {
      enableBackground: "new 0 0 233.3 200"
    },
    xmlSpace: "preserve",
    width: "3rem",
    height: "3rem",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n  .st0 { fill: #333d45; }\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.5,200h-8.3C13.2,200,0,186.8,0,170.8V62.5c0-16,13.2-29.2,29.2-29.2h8.3V200z M183.3,200H50V33.3h16.7V12.5 C66.7,5.6,72.3,0,79.2,0h75c6.9,0,12.5,5.6,12.5,12.5v20.8h16.7V200z M150,33.3V16.7H83.3v16.7H150z M233.3,170.8 c0,16-13.2,29.2-29.2,29.2h-8.3V33.3h8.3c16,0,29.2,13.2,29.2,29.2V170.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg25DaysHoliday);
export default __webpack_public_path__ + "static/media/25_Days_Holiday.1fe3674752119c70b970e655f7245e38.svg";
export { ForwardRef as ReactComponent };